// Console adapter for the first-party Messages v1 host. The wire contract and its defensive
// response parsing stay shared with mobile so both clients fail closed on the same RPC shapes.
// Channels Light remains a separate, announcement-only Boards host.

export {
  MESSAGE_POST_PAGE_LIMIT,
  fetchMessagePosts,
  fetchMessageThread,
  fetchMessageThreads,
  markMessagePostDelivered,
  markMessagePostSeen,
  messageReceiptLine,
  sendMessagePost,
} from "../../../../packages/shared/src/messages.ts";

export type {
  MessageLoad,
  MessagePost,
  MessageThread,
  MessageThreadDetail,
  MessageWrite,
  SentMessagePost,
} from "../../../../packages/shared/src/messages.ts";

/**
 * Console send is intentionally narrower than the host's cross-client send gate. Guards can
 * send from field clients, but only active supervisor/admin memberships get Console composer
 * chrome. Unknown, loading, support, and platform-only roles fail closed to read-only.
 */
export function canSendConsoleMessages(accountRole: string | null | undefined): boolean {
  return accountRole === "supervisor" || accountRole === "admin";
}
